import { render, staticRenderFns } from "./App.vue?vue&type=template&id=f72ab1b4"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=f72ab1b4&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.39_css-loader@6.11.0_webpack@5.108.1_postcss@8_af98908436b1eea2d9365cc6921dea49/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports